import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTenantBids } from 'app/entities/tenant-bids/tenant-bids.reducer';
import { ShipmentStatus } from 'app/shared/model/enumerations/shipment-status.model';
import { createEntity, getEntity, reset, updateEntity } from './tenant-bid-shipment.reducer';

export const TenantBidShipmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tenantBids = useAppSelector(state => state.tenantBids.entities);
  const tenantBidShipmentEntity = useAppSelector(state => state.tenantBidShipment.entity);
  const loading = useAppSelector(state => state.tenantBidShipment.loading);
  const updating = useAppSelector(state => state.tenantBidShipment.updating);
  const updateSuccess = useAppSelector(state => state.tenantBidShipment.updateSuccess);
  const shipmentStatusValues = Object.keys(ShipmentStatus);

  const handleClose = () => {
    navigate(`/tenant-bid-shipment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTenantBids({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tenantBidShipmentEntity,
      ...values,
      tenantBid: tenantBids.find(it => it.id.toString() === values.tenantBid?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          shipmentStatus: 'PACKAGED',
          ...tenantBidShipmentEntity,
          tenantBid: tenantBidShipmentEntity?.tenantBid?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tenantBidShipment.home.createOrEditLabel" data-cy="TenantBidShipmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tenantBidShipment.home.createOrEditLabel">Create or edit a TenantBidShipment</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tenant-bid-shipment-id"
                  label={translate('tinyMedicRestApp.tenantBidShipment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidShipment.active')}
                id="tenant-bid-shipment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidShipment.cursor')}
                id="tenant-bid-shipment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidShipment.lastUpdated')}
                id="tenant-bid-shipment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidShipment.microSec')}
                id="tenant-bid-shipment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidShipment.timestampEntry')}
                id="tenant-bid-shipment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidShipment.shipmentStatus')}
                id="tenant-bid-shipment-shipmentStatus"
                name="shipmentStatus"
                data-cy="shipmentStatus"
                type="select"
              >
                {shipmentStatusValues.map(shipmentStatus => (
                  <option value={shipmentStatus} key={shipmentStatus}>
                    {translate(`tinyMedicRestApp.ShipmentStatus.${shipmentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidShipment.carrier')}
                id="tenant-bid-shipment-carrier"
                name="carrier"
                data-cy="carrier"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantBidShipment.carrierMobileNo')}
                id="tenant-bid-shipment-carrierMobileNo"
                name="carrierMobileNo"
                data-cy="carrierMobileNo"
                type="text"
              />
              <ValidatedField
                id="tenant-bid-shipment-tenantBid"
                name="tenantBid"
                data-cy="tenantBid"
                label={translate('tinyMedicRestApp.tenantBidShipment.tenantBid')}
                type="select"
              >
                <option value="" key="0" />
                {tenantBids
                  ? tenantBids.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tenant-bid-shipment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TenantBidShipmentUpdate;
